/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2021, 2024 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import React from 'react';
import ReactDOM from 'react-dom';
import NavMain from './nav/NavMain';
import { updateCsrfToken } from './services/CsrfTokenService';
import {AppMsg, NavConfig, UserSession} from './utils';
import SessionExpired from "./session/SessionExpired";
import * as serviceWorker from './serviceWorker';
import {
    fetchTriAppConfig
} from "@tririga/tririga-react-components";
import wxoLoader from './wxoloader';

async function initAndRenderApp() {

    //If window was used for SSO Auth, close right away
    if (window.name === 'TririgaSSOAuthWin') {
      window.opener.closeSSOAuthWin();
      return;
    }

    await UserSession.checkUserSessionStatus();
    await UserSession.fetchIsSSO();
    await UserSession.fetchOAuthLoginProfile();

    if(UserSession.userHasActiveSession()){

        //Update Csrf token
        updateCsrfToken();

        // get application information
        await fetchTriAppConfig();
        
        // get nav config and user information
        await NavConfig.getNavConfigAndUserData();
        
        // initialize static messages
        await AppMsg.initMessages();

        // render watson orchestrate
        await wxoLoader()

        // render the application
        renderApp();
    }
    else{
        renderSessionExpired();
    }
}

async function renderApp() {
    ReactDOM.render(<NavMain />, document.getElementById('root'));

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: http://bit.ly/CRA-PWA
    serviceWorker.unregister();
}

async function renderSessionExpired(){
    ReactDOM.render(<SessionExpired />, document.getElementById('root'));
}

initAndRenderApp();